<div class="modal-header" *ngIf="parts">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body" *ngIf="parts" (keyup.esc)="close()">
    <dx-data-grid #dataGrid [dataSource]="parts" height="300px" keyExpr="id" [columnAutoWidth]="false" (onCellDblClick)="rowDoubleClick($event)">
        <dxi-column dataField="partNumber" caption="Part #" width="240"></dxi-column>
        <dxi-column dataField="description"></dxi-column>
        <dxi-column dataField="vendor.companyName" caption="Vendor" width="150"></dxi-column>
        <dxi-column dataField="onOrder" width="75"></dxi-column>

        <dxo-selection [mode]="'single'"></dxo-selection>
    </dx-data-grid>
</div>
<div class="modal-footer" *ngIf="parts">
    <button type="button" class="btn btn-primary" (click)="select()">Select</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
